import { auroraStore, useAuroraStore } from '../../store/auroraStore'

const KIND_LABEL: Record<string, string> = {
  rubric: 'Rubric',
  plan: 'Plan',
  activity: 'Activity',
  document: 'Document',
  book: 'Book',
  report: 'Report',
  photo: 'Photo',
}

/**
 * An artifact referenced from a message.
 *
 * `expanded` gives the richer card the agent's own output deserves; the compact
 * form is for things the parent attached.
 */
export function ArtifactChip({ artifactId, expanded }: { artifactId: string; expanded?: boolean }) {
  const artifact = useAuroraStore((s: any) => s.artifacts[artifactId])
  if (!artifact) return null

  const open = () => {
    const s = auroraStore.getState() as any
    s.selectArtifact(artifactId)
    if (artifact.kind === 'activity') s.setView('kid')
    else if (artifact.kind === 'plan') s.setView('today')
    else if (artifact.kind === 'rubric') s.setView('story')
    else s.setView('library')
  }

  if (!expanded) {
    return (
      <button className="artifact-chip" onClick={open}>
        {artifact.title}
      </button>
    )
  }

  return (
    <button className="artifact-card" onClick={open}>
      <span className="artifact-card-kind">{KIND_LABEL[artifact.kind] ?? artifact.kind}</span>
      <span className="artifact-card-title">{artifact.title}</span>
      {artifact.summary && <span className="artifact-card-summary">{artifact.summary}</span>}
      {artifact.version > 1 && (
        <span className="artifact-card-version">v{artifact.version}</span>
      )}
    </button>
  )
}
